var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 16.6665V14.9752C15.4166 13.9399 14.9505 12.9248 14.0085 12.4953C12.8595 11.9716 11.4815 11.6665 9.99992 11.6665C8.51834 11.6665 7.14034 11.9716 5.99132 12.4953C5.04931 12.9248 4.58325 13.9399 4.58325 14.9752V16.6665",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 9.16683C11.6107 9.16683 12.9166 7.86099 12.9166 6.25016C12.9166 4.63933 11.6107 3.3335 9.99992 3.3335C8.38909 3.3335 7.08325 4.63933 7.08325 6.25016C7.08325 7.86099 8.38909 9.16683 9.99992 9.16683Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5a4082343a77bbf653d6230a4dc133d1.svg";
export { ForwardRef as ReactComponent };